import { render, staticRenderFns } from "./sub_reflect_detail.vue?vue&type=template&id=5215c7f4&scoped=true"
import script from "./sub_reflect_detail.vue?vue&type=script&lang=js"
export * from "./sub_reflect_detail.vue?vue&type=script&lang=js"
import style0 from "./sub_reflect_detail.vue?vue&type=style&index=0&id=5215c7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5215c7f4",
  null
  
)

export default component.exports